import { axiosRequest } from "../api";
import { API_PATH } from "../../constants";

export const AuthService = {
  login(body) {
    return axiosRequest("POST", API_PATH.AUTH.LOGIN, body);
  },
  getCaptcha() {
    return axiosRequest("POST", API_PATH.AUTH.GET_CAPTCHA);
  },
  logout(refreshToken) {
    return axiosRequest("POST", API_PATH.AUTH.LOGOUT(refreshToken));
  },
  getMatrixInfo() {
    return axiosRequest("POST", API_PATH.AUTH.MATRIX_INFO);
  },
};
